








import Candle from "@/models/candle";
import CandleImage from "./CandleImage.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    CandleImage,
  },
})
export default class CandleInfo extends Vue {

  @Prop({
    default: 'normal'
  })
  scale?: string;

  @Prop({
    default: 'We Remember...'
  })
  text?: string;

  @Prop()
  candle?: Candle;
}
